/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review6_SubInputs */

const es_landing_review6_sub = /** @type {(inputs: Landing_Review6_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puesta de sol desde el mar`)
};

const gl_landing_review6_sub = /** @type {(inputs: Landing_Review6_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solpor desde o mar`)
};

const en_landing_review6_sub = /** @type {(inputs: Landing_Review6_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunset from the sea`)
};

/**
* | output |
* | --- |
* | "Sunset from the sea" |
*
* @param {Landing_Review6_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review6_sub = /** @type {((inputs?: Landing_Review6_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review6_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review6_sub(inputs)
	if (locale === "en") return en_landing_review6_sub(inputs)
	return es_landing_review6_sub(inputs)
});